import React from "react";
import Main from '../pages/main/main'
import {
    BrowserRouter,
    Routes,
    Route,
    Navigate,
} from "react-router-dom";
import {LayoutAdmin} from '../components/layout/layoutAdmin';
import {LayoutMain} from '../components/layout/layoutMain';
import {useSelector} from 'react-redux';
import {authSelector} from '../store/auth/auth';
import AuthenticateRoute from './authenticateRoute';
import RedirectIfAuthenticated from './redirectIfAuthenticateRoute';
import ReportsAttendance from "../pages/reportsAttendance/reportsAttendance"
import Reports from "../pages/reports/report"

export const RoutesComponent = () => {
    //const {access_token} = useSelector(authSelector);
    const {access_token} = useSelector(authSelector);
    
    return <BrowserRouter>
        <Routes>
            <Route
                path={''}
                element={
                    <Navigate to={"login"}/>
                }>
            </Route>
            <Route path='login'
                   element={<RedirectIfAuthenticated
                       path={'/login'}
                       redirectPath={'/home'}
                       isAuthenticated={access_token}
                   />}>
            </Route>

            <Route path='home'
                   element={<AuthenticateRoute
                       path={'/home'}
                       layout={LayoutMain}
                       component={Main}
                       authenticatePath={'/login'}
                       isAuthenticated={access_token}
                   />}>
            </Route>

            <Route path='reports-attendance'
                   element={<AuthenticateRoute
                       path={'/reports-attendance'}
                       layout={LayoutAdmin}
                       component={ReportsAttendance}
                       authenticatePath={'/login'}
                       isAuthenticated={access_token}
                   />}

            >
            </Route>
            <Route path='reports'
                   element={<AuthenticateRoute
                       path={'/reports'}
                       layout={LayoutAdmin}
                       component={Reports}
                       authenticatePath={'/login'}
                       isAuthenticated={access_token}
                   />}

            >
            </Route>
            <Route path="*" element={<Navigate to={access_token?'/home':'/login'} replace />} />
        </Routes>
    </BrowserRouter>
}
